var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.667 6a.667.667 0 0 0 0-1.334h-.666a.667.667 0 1 0 0 1.333h.666Zm7.334 0a.667.667 0 0 0 0-1.334H6.667a.667.667 0 1 0 0 1.333h5.334Zm.666 2a.667.667 0 0 1-.666.666H6.667a.667.667 0 0 1 0-1.333h5.334c.368 0 .666.298.666.666Zm-.666 3.333a.667.667 0 0 0 0-1.334H6.667a.667.667 0 1 0 0 1.334h5.334ZM5.334 7.999a.667.667 0 0 1-.667.667h-.666a.667.667 0 1 1 0-1.333h.666c.369 0 .667.298.667.666Zm-.667 3.334a.667.667 0 0 0 0-1.334h-.666a.667.667 0 1 0 0 1.334h.666Z",
    clipRule: "evenodd"
  })));
};
export default SvgList;